module.exports = {
  "props": [
    {
      "name": "dark",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the dark theme variant to the component. You can find more information on the Material Design documentation for [dark themes](https://material.io/design/color/dark-theme.html).",
        "eo-UY": ""
      }
    },
    {
      "name": "inset",
      "type": "boolean",
      "default": "false",
      "source": "v-subheader",
      "description": {
        "en": "Adds indentation (72px)",
        "eo-UY": ""
      }
    },
    {
      "name": "light",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the light theme variant to the component.",
        "eo-UY": ""
      }
    }
  ],
  "mixins": [
    "themeable"
  ],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "eo-UY": ""
      }
    }
  ],
  "events": [],
  "functions": [],
  "name": "v-subheader",
  "sass": [
    {
      "name": "$subheader-inset-margin",
      "default": "56px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$subheader-item-single-height",
      "default": "48px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$subheader-left-padding",
      "default": "16px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$subheader-right-padding",
      "default": "16px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    }
  ],
  "component": true
}